import { createContext, useCallback, useContext, useState } from "react";

const KEY = "archijo-theme";
const BG = { dark: "#0A0A0A", light: "#FAFAFA" };
const ThemeCtx = createContext({ theme: "dark", setTheme: () => {}, toggle: () => {} });

// Single source of truth: data-theme on <html> (set before paint by the inline script in index.html). Default dark.
const current = () => (document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark");

function apply(theme) {
  const root = document.documentElement;
  root.classList.add("theme-anim");
  window.setTimeout(() => root.classList.remove("theme-anim"), 250);
  root.setAttribute("data-theme", theme);
  root.style.background = BG[theme];
  document.body.style.background = BG[theme];
  document.getElementById("theme-boot")?.remove();
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", BG[theme]);
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(current);

  const setTheme = useCallback((t) => {
    try {
      localStorage.setItem(KEY, t);
    } catch {}
    apply(t);
    setThemeState(t);
  }, []);

  const toggle = useCallback(() => setTheme(theme === "dark" ? "light" : "dark"), [theme, setTheme]);

  return <ThemeCtx.Provider value={{ theme, setTheme, toggle }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
